var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * Moves/adds the given dropdownOption to the end of the returned array
 * If a previously selected dropdown option reappears in the dropdownOptions list then the
 * duplicate will be removed and appended to the end of the array
 *
 * @param {T} dropdownOptionToAppend The dropdown option that will always exist at the end of the array
 */
export var appendDropdownOptionToEnd = function (dropdownOptionToAppend) {
    return function (dropdownOptions) {
        if (dropdownOptions === void 0) { dropdownOptions = []; }
        if (!dropdownOptionToAppend) {
            return dropdownOptions;
        }
        // Return the dropdown options with the dropdownOptionToAppend attached to the end
        return __spreadArray(__spreadArray([], dropdownOptions.filter(function (dropdownOption) { return dropdownOption.id !== dropdownOptionToAppend.id; })), [
            dropdownOptionToAppend,
        ]);
    };
};
//# sourceMappingURL=appendDropdownOptionToEnd.js.map